import React from "react";
import "../StatusSaverPrivacyPolicy.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

const StatusSaverPrivacyPolicy = () => {
    const navigate = useNavigate(); // hook to navigate programmatically

    const goHome = () => {
    navigate('/'); // navigate to homepage
  };
  return (
    <div className="privacy-policy-page">
       <SEO
        title="Privacy Policy - Status Downloader- Save Status | BlueOrbit Technologies"
        description="Privacy Policy for Status Downloader- Save Status app. Learn how we protect your data and privacy."
        keywords="privacy policy, data protection, Status Downloader- Save Status privacy, BlueOrbit Technologies privacy"
      />
      <header className="privacy-header">
      <div className="container">
        <nav className="nav">
          <div className="logo" onClick={goHome} style={{ cursor: 'pointer' }}>
            <i className="fas fa-orbit"></i>
            <span>BlueOrbit Technologies</span>
          </div>
        </nav>
      </div>
    </header>

      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <ul className="breadcrumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/">Apps</a>
            </li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-header">
            <h2>Privacy Policy for Status Downloader- Save Status</h2>
            <p className="effective-date">Effective Date: [15-09-25]</p>
          </div>

          <div className="policy-content">
            <div className="policy-section">
              <h3>1. Information We Collect</h3>
              <p>
                We respect your privacy and do not collect any personal
                information unless you voluntarily provide it.
              </p>
              <ul>
                <li>
                  <strong>Non-Personal Information:</strong> We may collect
                  anonymous, aggregated usage data, such as app usage patterns
                  or device type, to improve app performance.
                </li>
                <li>
                  <strong>No Access to WhatsApp Accounts:</strong> Our app does
                  not access your WhatsApp account credentials, messages, or
                  personal chats. We only interact with the media
                  (images/videos) you have already viewed on your device.
                </li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>2. How We Use Your Information</h3>
              <p>
                The information we may collect is used for the following
                purposes:
              </p>
              <ul>
                <li>Improve app performance and user experience.</li>
                <li>Troubleshoot and fix bugs.</li>
                <li>Provide app updates and enhancements.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>3. Permissions</h3>
              <p>
                The app may request the following permissions on your device:
              </p>
              <ul>
                <li>
                  <strong>Storage/Media Access:</strong> Required to view and
                  download statuses from your device's WhatsApp media folder.
                </li>
                <li>
                  <strong>Internet Access (optional):</strong> Needed if sharing
                  statuses via social media or other platforms.
                </li>
              </ul>
              <p>
                Note: Permissions are used only to enable app functionality and
                are never used for advertising or personal tracking.
              </p>
            </div>

            <div className="policy-section">
              <h3>4. Sharing Your Information</h3>
              <p>
                We do not sell, trade, or share your personal information with
                third parties.
              </p>
              <ul>
                <li>
                  Shared content (like downloaded statuses) is handled locally
                  on your device.
                </li>
                <li>
                  Any sharing to social media platforms is initiated and
                  controlled by you.
                </li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>5. Data Security</h3>
              <p>
                We take reasonable measures to protect your information from
                unauthorized access or disclosure. However, no app or internet
                transmission can be guaranteed 100% secure. Use the app at your
                own risk.
              </p>
            </div>

            <div className="policy-section">
              <h3>6. Third-Party Services</h3>
              <p>Our app may include third-party services such as:</p>
              <ul>
                <li>Analytics services (for anonymous usage tracking)</li>
                <li>Optional sharing APIs (e.g., social media share)</li>
              </ul>
              <p>
                Note: Third-party services have their own privacy policies. We
                recommend reviewing them separately.
              </p>
            </div>

            <div className="policy-section">
              <h3>7. Children's Privacy</h3>
              <p>
                Our app is not intended for children under 13 years old. We do
                not knowingly collect personal information from children.
              </p>
            </div>

            <div className="policy-section">
              <h3>8. Changes to This Privacy Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. When we do,
                the updated policy will be posted here with the effective date.
                Please review this page periodically for changes.
              </p>
            </div>

            <div className="policy-section">
              <h3>9. Contact Us</h3>
              <p>
                If you have any questions or concerns about this Privacy Policy,
                please contact us at:
              </p>
              <p>
                Email: Blueorbittechnologies@gmail.com
                <br />
                {/* Website: [Your Website URL] */}
              </p>
              <p>
                By using the Status Saver app, you agree to this Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>BlueOrbit Technologies</h3>
              <p>
                Creating innovative mobile solutions that enhance your digital
                experience.
              </p>
            </div>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/">Our Apps</a>
                </li>
                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 BlueOrbit Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default StatusSaverPrivacyPolicy;
